export default __webpack_public_path__ + "static/media/snowun-footer.cf0a089c.webp";